import React, { useEffect } from "react";

import "./App.css";

import i18n from "./utils/translate";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import routes from "./routes/routes";

function App() {
  useEffect(() => {
    const handleLanguageChange = () => {
      // Language changed, component will re-render through i18n context
    };

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, []);

  return (
    <Router>
      <Routes>
        {routes.map(({ paths, element }) =>
          paths.map((path) => <Route key={path} path={path} element={element} />),
        )}
      </Routes>
    </Router>
  );
}

export default App;
